import { useTranslation } from "react-i18next";

import { CASE_DATA_FIELDS } from "@/domain/case/case-config";
import { formatCurrency } from "@/lib/format/datetime";

/** 業務データではない内部変数（画面に出しても判断の役に立たない）。 */
const INTERNAL_KEYS = new Set(["applied", "lane_owners", "escalated_lanes"]);

/**
 * 申請内容（起案で入力された値）。判定にはこれが要る。
 *
 * 項目はモデルごとに違うので、タスクが持つデータをそのまま並べる。既知のキー
 * （CASE_DATA_FIELDS）はラベルと書式を当て、知らないキーはキー名のまま出す
 * （固定の項目表だけに頼ると、他のモデルで何も出なくなる）。
 */
export function SubmittedContent({
  data,
}: {
  readonly data: Readonly<Record<string, unknown>>;
}) {
  const { t } = useTranslation("common");

  const entries = Object.entries(data).filter(
    ([key, value]) =>
      !key.startsWith("_") &&
      !INTERNAL_KEYS.has(key) &&
      value !== null &&
      value !== undefined &&
      value !== "" &&
      typeof value !== "object",
  );
  if (entries.length === 0) return null;

  return (
    <section className="border-border flex flex-col gap-2 rounded-md border p-3">
      <h2 className="text-sm font-semibold">{t("approvals.requestContent")}</h2>
      <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm">
        {entries.map(([key, value]) => {
          const known = CASE_DATA_FIELDS.find((field) => field.key === key);

          return (
            <div key={key} className="col-span-2 grid grid-cols-subgrid">
              <dt className="text-muted-foreground">{known?.label ?? key}</dt>
              <dd>
                {known?.format === "currency"
                  ? formatCurrency(String(value))
                  : String(value)}
              </dd>
            </div>
          );
        })}
      </dl>
    </section>
  );
}
